import Vue from 'vue'
import store from '@/store/index'

class LogonHelper {
  static async login (data) {
    let endpoint = `${process.env.VUE_APP_API_DOMAIN}/auth/login`
    return Vue.prototype.$http.post(endpoint, data)
      .then(res => res.data)
      .catch(err => console.log(err))
  }
  static refresh () {
    store.state.isLogged = sessionStorage.getItem('isLogged')
    store.state.fullname = sessionStorage.getItem('fullname')
    store.state.username = sessionStorage.getItem('username')
    store.state.token = sessionStorage.getItem('token')

    Vue.prototype.$http.defaults.headers.common['Token-Auth'] = sessionStorage.getItem('token')
  }
  static async check () {
    this.refresh()

    let endpoint = `${process.env.VUE_APP_API_DOMAIN}/auth/check`
    return Vue.prototype.$http.get(endpoint)
      .then(res => res.data.logged)
      .catch(err => console.log(err))
  }
}

export default LogonHelper
